import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/Index/Index'
import Login from '@/pages/Login/Login'
import AdminLogin from '@/pages/Login/AdminLogin'
import Register from '@/pages/Register/Register'
import ResetPassword from '@/pages/ResetPassword/ResetPassword'
import Course from '@/pages/Course/Course'
import PlayCourse from '@/pages/PlayCourse/PlayCourse'
import Material from '@/pages/Material/Material'
import Pay from '@/pages/Pay/Pay'
import PayConfirm from '@/pages/PayConfirm/PayConfirm'
import CoursePlayInfo from '@/pages/CoursePlayInfo/CoursePlayInfo'
import OrderConfirm from '@/pages/OrderConfirm/OrderConfirm'

import CustomerCenter from '@/pages/CustomerCenter/CustomerCenter'
import UpdatePassword from '@/pages/CustomerCenter/UpdatePassword/UpdatePassword'
import OrderList from '@/pages/CustomerCenter/OrderList/OrderList'
import CVideoClickHistory from '@/pages/CustomerCenter/VideoClickHistory/VideoClickHistory'
import CMaterialClickHistory from '@/pages/CustomerCenter/MaterialClickHistory/MaterialClickHistory'

import AdminCenter from '@/pages/AdminCenter/AdminCenter'
import VideoClickHistory from '@/pages/AdminCenter/VideoClickHistory/VideoClickHistory'
import VideoPlayHistory from '@/pages/AdminCenter/VideoPlayHistory/VideoPlayHistory'
import MaterialClickHistory from '@/pages/AdminCenter/MaterialClickHistory/MaterialClickHistory'
import AllCustomers from '@/pages/AdminCenter/AllCustomers/AllCustomers'
import AllOrders from '@/pages/AdminCenter/AllOrders/AllOrders'
import AllCourses from '@/pages/AdminCenter/AllCourses/AllCourses'
import AllInvoices from '@/pages/AdminCenter/AllInvoices/AllInvoices'
import AllCoursePlayInfo from '@/pages/AdminCenter/AllCoursePlayInfo/AllCoursePlayInfo'
import ReCache from '@/pages/AdminCenter/ReCache/ReCache'

Vue.use(VueRouter)

export default new VueRouter({
  mode:'history',
  routes: [  //要非常小心，是routes，不是routers，否则页面不会渲染
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/customerCenter',
      component: CustomerCenter,
      children: [
        {
          path: '',
          redirect: '/customerCenter/videoClickHistory'
        },
        {
          path: '/customerCenter/updatePassword',
          component: UpdatePassword
        },
        {
          path: '/customerCenter/orderList',
          component: OrderList
        },
        {
          path: '/customerCenter/videoClickHistory',
          component: CVideoClickHistory
        },
        {
          path: '/customerCenter/materialClickHistory',
          component: CMaterialClickHistory
        },
      ]
    },
    {
      path: '/pay',
      component: Pay
    },
    {
      path: '/payConfirm',
      component: PayConfirm
    },
    {
      path: '/coursePlayInfo',
      component: CoursePlayInfo
    },
    {
      path: '/orderConfirm',
      component: OrderConfirm
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/resetPassword',
      component: ResetPassword
    },
    {
      path: '/course',
      component: Course
    },
    {
      path: '/playCourse',
      component: PlayCourse
    },
    {
      path: '/material',
      component: Material
    },
    {
      path: '/cmLogin',
      component: AdminLogin
    },
    {
      path: '/adminCenter',
      component: AdminCenter,
      children: [
        {
          path: '',
          redirect: '/adminCenter/videoClickHistory'
        },
        {
          path: '/adminCenter/videoClickHistory',
          component: VideoClickHistory
        },
        {
          path: '/adminCenter/videoPlayHistory',
          component: VideoPlayHistory
        },
        {
          path: '/adminCenter/materialClickHistory',
          component: MaterialClickHistory
        },
        {
          path: '/adminCenter/allOrders',
          component: AllOrders
        },
        {
          path: '/adminCenter/allCustomers',
          component: AllCustomers
        },
        {
          path: '/adminCenter/allCourses',
          component: AllCourses
        },
        {
          path: '/adminCenter/allInvoices',
          component: AllInvoices
        },
        {
          path: '/adminCenter/allCoursePlayInfo',
          component: AllCoursePlayInfo
        },
        {
          path: '/adminCenter/reCache',
          component: ReCache
        },
      ]
    },
    {
      path: '*',
      component: Index
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js